import React, {useState, useEffect, useContext} from 'react';
import { useNavigate } from "react-router-dom";
import TextControl from './customizedInputs/TextControl';
import authServices from '../services/authServices';
import { InputContext } from '../contexts/InputContext';

const SignInGoogleModal = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [datosUsuario, setDatosUsuario] = useState({nombre: '', apellido: '', documento_identidad: '', token: ''});
  const [tokenGoogle, setTokenGoogle] = useState('');
  const [mostrarErrores, setMostrarErrores] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setDatosUsuario({...datosUsuario, 
        [name]: value
    })
  }

  const handleCallbackResponse = (response) => {
    setTokenGoogle(response.credential)
  }

  const signInGoogle = async (token) => {
    try {
      const data = await authServices.signInGoogle(token, datosUsuario);
      if(data.token){
        setAuthInformation({
          token: data.token, 
          nombre: data.nombre, 
          user_id: data.user_id, 
          rol: data.rol, 
          autenticado: true
        })
        localStorage.setItem('token', data.token);
        navigate(`/`);
        navigate(0)

      } else {
        setAuthInformation({token: undefined, user_id: undefined, rol: undefined, autenticado: false})
        localStorage.removeItem('token');
      }

    } catch (error) {
      if(error.response.status===422 && error.response.data.errors.length > 0){
        
        setMostrarErrores( error.response.data.errors.join("<br />") )
        setDatosUsuario({...datosUsuario, 
            nombre: error.response.data.extra_parameters.nombre,
            apellido: error.response.data.extra_parameters.apellido,
        })
        // setMostrarCamposUsuario(true)
      } else if(error.response.status===401){
        alert(error.response.data.error)
      }
    }
  }

  useEffect(() => {
    if(tokenGoogle.length > 0){
      signInGoogle(tokenGoogle)
    }
  }, [tokenGoogle]);

  useEffect(() => {
    /* global google */
    try{
      google.accounts.id.initialize({
        client_id: '930097961964-j46cv85e3um82s12mfiighorfd39jbf9.apps.googleusercontent.com',
        callback: handleCallbackResponse
      });
  
      google.accounts.id.renderButton(
        document.getElementById('signInDiv'),
        {theme: 'outline', size: 'large'}
      );
    }  catch (error) {
      console.log(error)
    }


  }, []);

  return (
    <div className="modal fade" id="signInGoogle" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">Ingreso desde Google</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            {mostrarErrores && (
              <>
                <div className='alert alert-warning alert-dismissible fade show'>
                  <div dangerouslySetInnerHTML={{__html: mostrarErrores}}></div>  
                  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                
                <TextControl
                  value={datosUsuario.nombre}
                  name={'nombre'}
                  handleInput={(e) => handleInput(e)}
                  type={'nombre'}
                />

                <TextControl
                  value={datosUsuario.apellido}
                  name={'apellido'}
                  handleInput={(e) => handleInput(e)}
                  type={'apellido'}
                />

                <TextControl
                  value={datosUsuario.documento_identidad}
                  name={'documento_identidad'}
                  handleInput={(e) => handleInput(e)}
                  type={'documento_identidad'}
                />
              </>
            )}

            <div id="signInDiv"></div>

          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInGoogleModal;